import "./Navigation.css";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";

const Navigation = () => {
  return (
    <Navbar
      bg="white"
      data-bs-theme="light"
      sticky="top"
      style={{ boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)" }}
    >
      <Container>
        <Navbar.Brand>
          <img
            alt=""
            src="buono-logo.svg"
            width="30"
            height="30"
            className="d-inline-block align-top"
          />{" "}
          Buono
        </Navbar.Brand>
      </Container>
    </Navbar>
  );
};

export default Navigation;
